import { isEmpty, isNil } from 'lodash';
import {
  AuthenticationPayloadBase,
  AuthenticationPayloadV1,
  AuthenticationPayloadV2,
  isPayloadV1,
  isPayloadV2,
} from '~domain/model/authentication/authentication-payload';

export function adaptAccessToken(payload: AuthenticationPayloadBase): AuthenticationPayloadV2 {
  if (isNil(payload)) return undefined;
  if (isPayloadV1(payload)) payload = adaptToV2(payload);
  if (!isPayloadV2(payload)) throw new Error('Invalid token.');

  return payload;
}

function adaptToV2(payload: AuthenticationPayloadV1): AuthenticationPayloadV2 {
  if (!isNil(payload.applicationId) && !isEmpty(payload.applicationId)) {
    return {
      resource: {
        id: payload.applicationId,
        type: 'application',
      },
      scope: payload.scope,
      version: 2,
    };
  }

  if (payload.isAdmin) {
    return {
      resource: {
        id: undefined,
        type: 'adminAccount',
      },
      scope: payload.scope,
      version: 2,
    };
  }

  return undefined;
}
